<template>
  <div name="demo-searchbox-codpos">
    <div class="row">
      <div class="form-group col-xs-12 col-md-6">
        <hrms-lov v-model="codpos1"
                  lovType="codpos"
                  :disabled="false"
                  :nowLang="nowLang"
                  name="codpos1" />
        <hrms-lov v-model="codpos2"
                  lovType="codpos"
                  :disabled="true"
                  :nowLang="nowLang"
                  name="codpos2" />
        <hrms-lov v-model="codpos3"
                  lovType="codpos"
                  :disabled="false"
                  :nowLang="nowLang"
                  name="codpos2" />
      </div>
    </div>
    <hrms-search-box	 :receivedStore="receivedStore"
	        			 :nowLang="nowLang"
	        			 :searchBoxAlias="searchBoxAlias" />
  </div>
</template>

<script>
import env from 'src/../env.js'

export default {
  name: 'demo-searchbox-codpos',
  data () {
    return {
      codpos1: '',
      codpos2: '',
      codpos3: '',
      nowLang: window.localStorage.getItem(env.site + '_lang'),
      searchBoxAlias: 'demo-lov-codpos'
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxCodpos.vue?3ac96088